/* eslint-disable */
// Original Source - https://github.com/imbugs/script-inner-html
// Imported into the project because it would not transpile in babel correctly
import React from 'react';
import parse5 from 'parse5';
import flatten from 'lodash/flatten';
import fbemitter from 'fbemitter';
import createReactClass from 'create-react-class';

const isBrowser = !!(document && window);

var totalNumber = 0;
var loadNumber = 0;
var toLoadSrc = [];
var emitter = new fbemitter.EventEmitter();

emitter.addListener('loaded', function () {
  loadNumber++;
  onLoaded();
});

var onLoaded = function (src) {
  src && toLoadSrc.push(src);
  if (loadNumber >= totalNumber) {
    toLoadSrc.map(function (s) {
      loadText(s);
    })
    toLoadSrc = [];
  }
}

var loadSrc = function (src) {
  totalNumber++;
  const script = document.createElement("script");
  script.src = src;
  script.onload = function () {
    emitter.emit('loaded');
  }
  script.async = false;
  document.body.appendChild(script);
}

var loadText = function (src) {
  const script = document.createElement("script");
  script.innerHTML = src;
  script.async = false;
  document.body.appendChild(script);
}


var findScritps = function (node) {
  if (node.tagName && node.tagName === 'script') {
    if (node.childNodes && node.childNodes.length > 0) {
      return (node.childNodes || []).map(function (n) {
        return n.value
      });
    } else {
      var srcs = (node.attrs || []).map(function (n) {
        if (n['name'] == 'src') {
          return n.value;
        }
      });

      var fns = (srcs || []).map(function (n) {
        n && loadSrc(n);
      })
    }
  }

  return flatten((node.childNodes || []).map(findScritps));
};

var run = function () {
  const scripts = ((this.state || {}).scripts || []);
  var fns = scripts.map(function (src) {
    src && onLoaded(src);
  })
};

export default createReactClass({
  clean: function () {
    if (!this.state.id || !isBrowser) {
      return;
    }

    const node = document.getElementById(this.state.id);

    if (!node) {
      return;
    }

    while (node.hasChildNodes()) {
      node.removeChild(node.lastChild);
    }
  },
  parse: function (props) {
    const html = (props || {}).html;

    if (!html || typeof html !== 'string') {
      return;
    }
    return findScritps(parse5.parseFragment(html));
  },
  uniqueId: function() {
    return 'id-' + Math.random().toString(36).substr(2, 16);
  },
  initialState: function (props) {
    return {
      id: (this.state || {}).id || this.uniqueId(),
      scripts: this.parse(props)
    };
  },
  getInitialState: function () {
    return this.initialState(this.props);
  },
  shouldComponentUpdate: function (nextProps) {
    return this.props.html !== nextProps.html;
  },
  componentWillReceiveProps: function (nextProps) {
    if (this.props.html === nextProps.html) {
      return;
    }

    this.clean();
    this.setState(this.initialState(nextProps));
  },
  componentDidMount: run,
  componentDidUpdate: run,
  render: function () {
    if (typeof this.props.html !== 'string') {
      return null;
    }

    return React.createElement('div', {
      id: this.state.id,
      dangerouslySetInnerHTML: {
        __html: this.props.html
      }
    });
  }
});



// WEBPACK FOOTER //
// ./src/components/util/ScriptInnerHtml.jsx